<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: displayMode === DisplayMode.Form }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Canaux de réception"
                createIconText="Ajouter un canal"
                importDatasourceName="channels"
                (created)="onChannelCreated()"
                (exported)="onchannelsExported()"
                (imported)="onchannelsImported()"
                (helped)="onchannelsHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-channel-list
            #itemsList
            (itemSelected)="onChannelSelected($event)"
            (itemDisplayed)="onChannelDisplayed($event)"
            (itemEdited)="onChannelEdited($event)"
            (itemDeleted)="onChannelDeleted($event)"
            (itemDuplicated)="onChannelDuplicated($event)"></app-channel-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onChannelDisplayed(context?.formContext.item)"
                    (edited)="onChannelEdited(context?.formContext.item)"
                    (helped)="onchannelsHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-channel-detail [context]="context" (channelUpdated)="channelUpdated($event)" (canceled)="onBackToList()"></app-channel-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
